// extracted by mini-css-extract-plugin
module.exports = {"divider":"settings_divider__3Veqw","small":"settings_small__GDJDe"};